<template>
	<div class="SeekDetails_container">
		<div class="SeekDetails_content">
			<div class="SeekDetails_img">
				<img draggable="false" :src="trackingRecord.trackimg" />
			</div>
			<div class="SeekDetails_text">
				<div class="SeekDetails_text_list">
					<span>姓名：{{trackingRecord.trackname}}</span>
					<span v-if="trackingRecord.tracksex=='1'">性别：男</span>
					<span v-if="trackingRecord.tracksex=='2'">性别：女</span>
				</div>
				<div class="SeekDetails_text_list">
					<span>年龄：{{trackingRecord.trackage}}</span>
					<span>身高：{{trackingRecord.height}}</span>
				</div>
				<div class="SeekDetails_trackdescribe">{{trackingRecord.trackdescribe}}</div>
			</div>
		</div>
		<div class="SeekDetails_btn" v-if="Seek=='myseek'&&trackingRecord.status=='1'">
			<div class="SeekDetails_btn_text" @click="modifyStatus">我已找到</div>
		</div>
		<div class="SeekDetails_btn" v-if="Seek=='myseek'&&trackingRecord.status!='1'">
			<div class="SeekDetails_btn_text" @click="deleteStatus">删除</div>
		</div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'SeekDetails',
		data() {
			return {
				baseUrl: "",
				trackid: "",
				trackingRecord: [],
				loading: true,
				loadingEnd: false,
				Seek:"",
				access_token:""
			}
		},
		methods: {
			modifyStatus() {
				var that = this;
				var that = this;
				wclient.view.showLoading();
				wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
				wclient.ajax({
					type: "GET",
					url: that.baseUrl + '?ugi=tracking&action=trackingEdit',
					dataType: "json",
					async: true,
					data: {
						access_token: that.access_token,
						trackid: that.trackid,
						status: '2'
					},
					success: function(data) {
						wclient.view.hideLoading();
						if(data.code == 'A00006') {
							that.$router.push({
								name: 'SearchForPeople'
							});
						}
					}
				});
			},
			deleteStatus() {
				var that = this;
				wclient.view.showLoading();
				wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
				wclient.ajax({
					type: "GET",
					url: that.baseUrl + '?ugi=tracking&action=trackingEdit',
					dataType: "json",
					async: true,
					data: {
						access_token: that.access_token,
						trackid: that.trackid,
						status: '9'
					},
					success: function(data) {
						wclient.view.hideLoading();
						if(data.code == 'A00006') {
							that.$router.push({
								name: 'SearchForPeople'
							});
						}
					}
				});
			},
			ToHome() {
				var that = this;
				that.$router.back(-1)
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "http://operation.xs.weapi.org/reception/ajax";
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "http://operation.xs.weapi.org/reception/ajax";
			} else {
				var baseUrl = "https://www.xiangshan1949.cn/reception/ajax";
			}
			that.baseUrl = baseUrl;
			that.trackid = sessionStorage.getItem('trackid')
			that.Seek = sessionStorage.getItem('Seek')
			that.access_token=localStorage.getItem('access_token')
			wclient.view.showLoading();
			wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
			wclient.ajax({
				type: "GET",
				url: that.baseUrl + "?ugi=tracking&action=chackTrackdetails&trackid=" + that.trackid,
				dataType: "json",
				async: true,
				data: {

				},
				success: function(data) {
					if(data.code == 'A00006') {
						wclient.view.hideLoading();
						that.trackingRecord = data.trackingRecord
					}
				}
			});
		}
	}
</script>

<style scoped>
	.SeekDetails_container {
		width: 100%;
		height: 100vh;
		background: white;
		margin: 0 auto;
		position: relative;
		-moz-user-select: none;
		-webkit-user-select: none;
		user-select: none;
		-webkit-overflow-scrolling: touch;
	}
	
	.SeekDetails_container>img {
		position: absolute;
		top: 55px;
		left: 5%;
		width: 6%;
		z-index: 999;
	}
	
	.SeekDetails_top {
		width: 90%;
		padding: 20px 5%;
	}
	
	.SeekDetails_top div:nth-child(1) {
		text-align: center;
		color: white;
		font-size: 45px;
		line-height: 130px;
	}
	
	.SeekDetails_content {
		width: 100%;
		background: white;
		overflow-y: auto;
		padding-bottom: 10vh;
		-ms-overflow-style: none;
	}
	
	.SeekDetails_img {
		width: 100%;
		padding: 20px 0;
		border-bottom: 4px solid #F4F4F4;
	}
	
	.SeekDetails_img img {
		width: 45%;
		margin: 0 auto;
	}
	
	.SeekDetails_text {
		width: 90%;
		margin: 0 auto;
	}
	
	.SeekDetails_text_list {
		width: 100%;
		border-bottom: 1px solid #b1b1b1;
		line-height: 40px;
		color: black;
		font-size: 14px;
	}
	
	.SeekDetails_text_list span {
		margin-right: 50px;
	}
	
	.SeekDetails_trackdescribe {
		width: 100%;
		padding: 10px 0;
		color: #232323;
		font-size: 15px;
		text-indent: 20px;
	}
	
	.SeekDetails_btn {
		width: 100%;
		background: white;
		border-top: 1px solid #eee;
		position: fixed;
		bottom: 0;
		left: 0;
	}
	
	.SeekDetails_btn_text {
		width: 70%;
		line-height: 40px;
		text-align: center;
		background: rgba(215, 43, 39, 1);
		color: #FEFEFE;
		border-radius: 20px;
		font-size: 14px;
		margin: 15px auto;
	}
</style>


// WEBPACK FOOTER //
// src/components/SeekDetails.vue